export const CUSTOMER_ADMIN = 'Company Administrator'
export const DEALER_ADMIN = 'Dealer Administrator'
export const INTERNAL_ADMIN = 'Internal Administrator'
